/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".prompt-modal .body{width:100%;max-height:450px;min-height:55px;overflow-y:auto;text-align:left;padding:16px 0}.prompt-modal .body .message{text-align:center}.prompt-modal .checkbox{margin-bottom:20px}.prompt-modal .cancel-btn{margin-top:24px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.prompt.modal/show.prompt.modal.component.scss.ngstyle.js.pre-build-optimizer.js